import {isValid, parse, format} from 'date-fns';

export const mapDateValue = (value: number | string | null | undefined): string | undefined => {
  if (value == null) return undefined;

  const str = value.toString();
  const isoDate = parse(str, 'yyyy-MM-dd', new Date());
  if (isValid(isoDate)) return str;

  const compactDate = parse(str, 'yyyyMMdd', new Date());
  if (!isValid(compactDate)) return str;

  return format(compactDate, 'yyyy-MM-dd');
};
